export const LOCALES = ['ar_SA', 'ca_ES', 'cs_CZ', 'da_DK', 'de_DE', 'el_GR', 'en_GB', 'en_US', 'es_ES', 'es_MX', 'fi_FI', 'fr_CA', 'fr_FR', 'hr_HR', 'hu_HU', 'id_ID', 'it_IT', 'iw_IL', 'ja_JP', 'ko_KR', 'ms_MY', 'nl_NL', 'no_NO', 'pl_PL', 'pt_BR', 'pt_PT', 'ro_RO', 'ru_RU', 'sk_SK', 'sv_SE', 'th_TH', 'tr_TR', 'uk_UA', 'vi_VI', 'zh_CN', 'zh_HK', 'zh_TW'];



// WEBPACK FOOTER //
// ./src/Constants.js